import styles from './FadedCard.module.css';

export const FadedCard = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.fadedCard}>{children}</div>;
};
